<template lang='pug'>
  v-container(fluid).products-container
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    //- Dialogs
    v-dialog(persistent  v-if='createItemDialog' :value='createItemDialog'  max-width='650px' max-height='100%' :fullscreen='isMobile' transition="dialog-bottom-transition")
      create-item( @close="createItemDialog=false" v-if='createItemDialog' )
    //- Preview
    v-dialog(persistent  v-if='dialog' :key='currentItem.name' :value='dialog'  max-width='800px' max-height='100%' :fullscreen='isMobile' transition="dialog-bottom-transition")
      Preview(:model ='currentItem' v-if="dialog" @close="dialog=false" @edit="editItem(currentItem.id)" @delete="openDeleteDialog(currentItem)" :showOptions="true")
    //- Update
    v-dialog(persistent :key='currentItem.id' v-if='updateItemDialog' :value='updateItemDialog' max-width='800px' max-height='100%' :fullscreen='isMobile' transition="dialog-bottom-transition")
      update-item(:model ='currentItem' v-if='updateItemDialog' @close="updateItemDialog=false;dialog=true")
    //- Delete
    //- v-dialog( v-model='confirmationDialog' width="500px" persistent transition="dialog-bottom-transition")
      v-card(outlined).card__confirmation-dialog
        v-card-title
          | Eliminar Producto
          v-spacer
            v-icon(aria-label="Close" @click="confirmationDialog = false")
              | mdi-close
        v-card-text.body-1.text-center
          | ¿Esta seguro de eliminar este Producto? {{isLastProductInshop ? 'se desactivaran las siguientes tiendas virtuales: ' + virtualShopsNamesToDelete : ''}}
        v-card-actions.text-center
          v-spacer
            v-btn(color='green darken-1', flat='', @click.native='confirmationDialog = false') No, cancelar
            v-btn(color='red darken-1', flat='', @click.native='deleteItem(currentItemId)') Si, proceder
    //- taxes
    v-dialog(v-model='dialogTaxes' :fullscreen="isMobile" scrollable='' max-width='400px')
      div(style ='position:relative; height: 100%;')
        taxes-dialog(@Close="dialogTaxes=false")
    //- Content
    v-row().justify-center
      //- Categories
      v-col.categories-container-shop(cols="12" xs="12" sm="12" md="4")
        Categories(@createProduct="createItemDialog=true" :inventory="Items" @taxes="dialogTaxes = true" :getProductStock="getProductStock" :getBundleStock="getBundleStock" :getBundleCost="getBundleCost" :getProductPrice="getProductPrice" :totalTaxes="totalTaxes" :getProductUtility="getProductUtility" :getPorcentualProductUtility="getPorcentualProductUtility" :getProductSold="getProductSold")
        //- Search
        //- v-text-field(label='Buscar' solo prepend-inner-icon='mdi-magnify' v-model='q' @input='setQuery(q)' clearable).ml-2
        //- Options mobile
        //- v-btn(small color="#6c1ea1" dark="" @click="createDialog = true" block).px-0.py-6 Crear
          v-icon.mx-2 mdi-pencil-box
          //- v-row(justify="center")
          v-dialog(:value="createDialog" transition="dialog-bottom-transition")
            v-card
              v-row.pt-4.pr-4.justify-end
                v-btn(fab="" dark="" x-small color="grey" @click="createDialog = false")
                  v-icon(dark="")
                    | mdi-close
              v-list
                v-list-item(@click="createItemDialog=true; createDialog = false;").my-2
                  v-img(:src="createProduct" contain style="width: 2.5rem;").mx-4
                  v-list-item-title Crear producto
                v-divider.divider-length
                v-list-item(@click="$router.push('/dashboard/products/inventory'); createDialog = false;").my-2
                  v-img(:src="uploadInventory" contain style="width: 2.5rem;").mx-4
                  v-list-item-title Subir inventario
                v-divider.divider-length
                v-list-item(@click="onexport(); createDialog = false;").my-2
                  v-img(:src="carryInventory" contain style="width: 2.5rem;").mx-4
                  v-list-item-title Exportar inventario
      //- Products
      v-col.my-1.py-0(cols="12" xs="12" sm="12" md="8" )
        v-card.pa-3.mt-1(height="100%" width="100%")
          v-row.px-0(no-gutters).sticky
            v-col.px-0.text-center( v-if ='isMobile' cols="12" xs="12" sm="12" md="12")
                v-text-field.rounded-xl(label='Buscar' height="10" dense elevation=0 outlined prepend-inner-icon='mdi-magnify' v-model='q' @input='setQuery(q)' clearable)
            v-col.px-0.text-center( v-if ='!isMobile' cols="12" xs="12" sm="12" md="12")
              v-text-field.rounded-xl(label='Buscar' height="10" dense elevation=0 outlined prepend-inner-icon='mdi-magnify' v-model='q' @input='setQuery(q)' clearable)
              v-btn(small color="#008E95" dark @click="createItemDialog=true").mx-1
                |Crear producto
                v-icon mdi-plus
              v-btn(small color="main" dark to="/dashboard/products/inventory").mx-1
                |Subir inventario
                v-icon mdi-arrow-up
              v-btn(small color="secondary" dark @click="dialogTaxes = true").mx-1
                |Impuestos
                v-icon mdi-gesture-swipe-up
              v-btn(small color="primary" dark @click="onexport()").mx-1
                |Exportar inventario
                v-icon mdi-share
          v-row
            v-col(cols='12' md='12').pt-0
              .products-table-container.pb-5
                //- Table desktop
                v-data-table.show-table-desktop(v-if='Items && Items.length > 0  && !loadingItems' :headers="headers" :items="Items" :custom-sort="customSort" :search="search" :custom-filter="customFilter" height="80vh")
                  template(v-slot:item="{ item }" v-slot:scope="{ item }")
                    tr(:key="item.id")
                      td(:style="getProductStock(item).showLowStockAlert ? 'border-left: 5px solid #FF5722' : 'border-left: 5px solid transparent'")
                        v-img.mx-auto(
                            contain
                            :src="getImage(item.pictures.imageInput1)"
                            @error='item.pictures.imageInput1 = productPlaceHolder'
                            height="65"
                            max-width="50"
                          )
                          template(v-slot:placeholder="")
                            v-row.fill-height.ma-0(align="center" justify="center")
                              v-progress-circular(indeterminate="" color="primary")
                      td
                        .primary--text.hover-cursor(v-text="item.name"  @click.stop="showItem(item)").product__title--table
                      td.text-left(v-if = 'item.type !== "bundle"' v-text="getProductStock(item).result")
                      td(v-else v-text="getBundleStock(item).result")
                      td(v-if = 'item.type !== "bundle"' v-text="item.price.buy")
                      td(v-else v-text="getBundleCost(item)")
                      td.text-left(v-text="getProductPrice(item)")
                      td.text-left(v-text="totalTaxes(item)")
                      td.text-left(v-text="getProductUtility(item)" style="max-width: 150px;")
                      td.text-left(v-text="getPorcentualProductUtility(item)" style="max-width: 150px;")
                      td.text-left(v-text="getProductSold(item) || 0")
                //- Mobile
                v-row.show-table-mobile(v-if='Items && Items.length > 0 && !loadingItems' style="postion: relative;").px-2
                  template(v-for='(item, index) in Items')
                    v-col(@click="showItem(item)" cols="6").pa-1.pt-3
                      v-row.product.elevation-4
                        v-col(cols="12" :class="`product__title-area--${item.type}`").product__title-area
                          span.product__title {{item.name}}
                        v-col(cols="6").px-0
                          v-row.text-center
                            v-col(cols="12").mb-0.pb-0
                              img(:src="getImage(item.pictures.imageInput1)" @error='item.pictures.imageInput1 = productPlaceHolder' :style="item.showLowStockAlert ? 'border-left: 10px solid rgb(255, 161, 91)' : ''").product__img
                            v-col(cols="12").ma-0.pa-0
                              span(style="display: inline-flex; font-size: 1rem;").product__item-amount {{ '$' + getProductPrice(item) | numberFormat}}
                        v-col(cols="6")
                          v-row.mx-0.text-center
                            v-col(cols="12" v-if="!item.type || item.type==='product' || item.type==='bundle'").ma-0.pa-0
                              span.product__item-title Inventario
                              span(v-if='item.type !== "bundle"').product__item-amount {{getProductStock(item).result}}
                              span(v-else).product__item-amount {{getBundleStock(item).result}}
                            v-col(cols="12" v-if="!item.type || item.type==='product' || item.type==='bundle'").ma-0.pa-0
                              span.product__item-title T. Ventas
                              span.product__item-amount {{getProductSold(item) || 0 }}
                            v-col(cols="12" v-if="item.type==='service'").ma-0.pa-0
                              span.product__item-title T. Ventas
                              span.product__item-amount {{getProductSold(item) || 0}}
                //- Skeleton
                v-col(v-if="loadingItems" cols="12" style="overflow: hidden").text-center
                  v-row.my-2
                    v-skeleton-loader( width='100%' type="list-item-avatar-two-line").mx-auto
                  v-row.my-2
                    v-skeleton-loader( v-for='i in 20' max-width="110px" max-height='110px' width='100%' height='110px' type="card").mx-auto.my-2
                  v-row.my-2
                    v-skeleton-loader(  width='100%' type="list-item-avatar-two-line").mx-auto
                  v-row.my-2
                    v-skeleton-loader(v-for='i in 20'  max-width="110px" max-height='110px' width='100%' height='110px' type="card").mx-auto.my-2
                  v-row.my-2
                    v-skeleton-loader(  width='100%' type="list-item-avatar-two-line").mx-auto
                //- No results
                noResults(v-if="!loadingItems && Items.length === 0" :title="'No tienes productos en esta categoria'" :description="'En esta sección encontraras los productos de acuerdo a la categoria seleccionada'")
</template>

<script>
  import XLSX from 'xlsx'
  import loaders from '@/plugins/mixins/loaders'
  import { mapMutations, mapState } from 'vuex'
  import CreateItem from './CreateProduct'
  import Preview from '../../components/custom/preview/ProductPreview'
  import UpdateItem from './UpdateProduct'
  import productPlaceHolder from '@/assets/icons/products.png'
  import TaxesDialog from '@/components/custom/dialogs/TaxesDialog'
  import shopPlaceHolder from '../../assets/icons/shop.svg'
  import createProduct from '@/assets/icons/actions/create-product.png'
  import uploadInventory from '@/assets/icons/actions/upload-inventory.png'
  import carryInventory from '@/assets/icons/actions/invoice.png'
  import moment from 'moment'
  import Swal from 'sweetalert2'

  export default {
    components: {
      CreateItem: CreateItem,
      Preview: Preview,
      UpdateItem: UpdateItem,
      TaxesDialog: TaxesDialog,
      Categories: () => import('@/views/custom/Categories'),
      noResults: () => import('@/components/custom/NoResults.vue'),
    },
    filters: {
      numberFormat (val) {
        if (val) { return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
    },
    mixins: [loaders],
    data () {
      return {
        createProduct,
        uploadInventory,
        carryInventory,
        search: '',
        createDialog: false,
        dialogTaxes: false,
        isLastProductInshop: false,
        virtualShopsIdsToDelete: [],
        virtualShopsNamesToDelete: '',
        currentLocation: null,
        loadingItems: false,
        shopSearch: false,
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        rules: {
          required: value => !!value || 'Campo Requerido',
        },
        isMobile: false,
        headers: [
          {
            sortable: false,
            text: 'Imagen',
            value: 'imagen',
            align: 'center',
          },

          {
            sortable: true,
            text: 'Nombre',
            value: 'name',
            align: 'center',
          },
          {
            sortable: true,
            text: 'Stock',
            value: 'stock',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Inversion',
            value: 'buy',
            align: 'left',

          },
          {
            sortable: true,
            text: 'Venta',
            value: 'sale',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Impuestos',
            value: 'taxes',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Utilidad',
            value: 'utility',
            align: 'center',
          },
          {
            sortable: true,
            text: '% de Utilidad',
            value: 'porcentualutility',
            align: 'center',
          },
          {
            sortable: true,
            text: 'Vendidos',
            value: 'sold',
            align: 'left',
          },
        ],
        currentItemId: null,
        dialog: false,
        createItemDialog: false,
        updateItemDialog: false,
        confirmationDialog: false,
        q: '',
        productPlaceHolder: productPlaceHolder,
      }
    },
    computed: {
      ...mapState(['change']),
      currentShop () {
        return this.$store.getters['shops/getCurrentItem']
      },
      smallScreen () {
        return window.innerWidth < 1500 && window.innerWidth >= 1024
      },
      allShops () {
        return this.$store.getters['shops/getItems']
      },
      currentCategory () {
        return this.$store.getters['categories/getCurrentItem']
      },
      currentItem () {
        return this.$store.getters['products/getCurrentItem']
      },
      allItems () {
        return this.$store.getters['products/getAllItems']
      },
      Items () {
        try {
          if (this.currentShop && Object.keys(this.currentShop).length !== 0 && !!this.$store.getters['products/getItems']) {
            // console.log('tienda seleccionada : ', this.currentShop.name)
            if (this.currentCategory.type === 'default' && this.currentCategory.name === 'HOT') {
              return this.customSort(this.$store.getters['products/getItems'], ['sold'], [true])
            } else if (this.currentCategory.type === 'default' && this.currentCategory.name === 'SOLDOUT') {
              const products = this.$store.getters['products/getItems']
              products.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : -1)
              return products // el filtrado se hace en el getter
            } else {
              return this.$store.getters['products/getItems']
                .filter(item => {
                  return !!(item.location && item.location[this.currentShop.id])
                })
            }
          } else {
            // console.log('no hay tienda')
            if (this.currentCategory.type === 'default' && this.currentCategory.name === 'HOT') {
              return this.customSort(this.$store.getters['products/getItems'], ['sold'], [true])
            } else {
              // para el soldOut se hace el filtro en el store(getter)
              // y para obtener todo el inventario se llama el mismo getter
              const products = this.$store.getters['products/getItems']
              products.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : -1)
              return products
            }
          }
        } catch (err) {
          // console.log('ENTRA EN UN ERROR ', err)
          const products = this.$store.getters['products/getItems']
          products.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : -1)
          return products
        }
      },
      field () {
        return {
          locations: this.$store.getters['shops/getItems'],
          categories: this.$store.getters['categories/getItems'],
        }
      },
    },
    watch: {
      $route (to, from) {
        // console.log(this.$route)
        const vm = this
        if (to.fullPath.includes('dashboard/products/')) {
          vm.fetch()
        }
      },
    },
    beforeCreate () {
      const vm = this
      if (window.innerWidth < 1024) {
        vm.$store.dispatch('categories/setCurrentItem', { name: 'HOT', type: 'default' }).then(() => {

        })
      }
    },
    created () {
      // vm.fetch()
      // vm.loadProducts()
    },
    mounted () {
      const vm = this
      vm.onResize()
      window.addEventListener('resize', vm.onResize, { passive: true })
      vm.loadingItems = true
      setTimeout(() => {
        vm.loadingItems = false
      }, 4000)
      // const vm = this
      // vm.$store.dispatch('categories/loadItems', 'categories').then(() => {})
      vm.currentLocation = vm.$store.getters['shops/currentItem']
    },
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
    methods: {
      customFilter (value, search, item) {
        return item.name.toLowerCase().includes(search.toString().toLowerCase())
      },
      customSort (items, index, isDesc) {
        const vm = this
        items.sort((a, b) => {
          if (index[0] === 'name') {
            // comparacion de cadena
            if (!isDesc[0]) {
              return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
            } else {
              return b.name.toLowerCase().localeCompare(a.name.toLowerCase())
            }
          } else if (index[0] === 'stock') {
            let stocka
            let stockb
            if (a.type !== 'bundle') {
              stocka = vm.getProductStock(a)
              if (a.magnitude) {
                stocka = stocka.split(' ')[0]
              }
            } else {
              stocka = vm.getBundleStock(a)
            }

            if (b.type !== 'bundle') {
              stockb = vm.getProductStock(b)
              if (b.magnitude) {
                stockb = stockb.split(' ')[0]
              }
            } else {
              stockb = vm.getBundleStock(b)
            }
            if (!isDesc[0]) {
              return parseFloat(stocka) - parseFloat(stockb)
            } else {
              return parseFloat(stockb) - parseFloat(stocka)
            }
          } else if (index[0] === 'buy') {
            let buya
            let buyb
            if (a.type !== 'bundle') {
              buya = a.price.buy
            } else {
              buya = vm.getBundleCost(a)
            }
            if (b.type !== 'bundle') {
              buyb = b.price.buy
            } else {
              buyb = vm.getBundleCost(b)
            }
            if (!isDesc[0]) {
              return parseFloat(buya) - parseFloat(buyb)
            } else {
              return parseFloat(buyb) - parseFloat(buya)
            }
          } else if (index[0] === 'sale') {
            let salea
            let saleb
            if (a.type === 'ingredient') {
              salea = -1
            } else {
              salea = vm.getProductPrice(a)
            }
            if (b.type === 'ingredient') {
              saleb = -1
            } else {
              saleb = vm.getProductPrice(b)
            }
            if (!isDesc[0]) {
              return parseFloat(salea) - parseFloat(saleb)
            } else {
              return parseFloat(saleb) - parseFloat(salea)
            }
          } else if (index[0] === 'taxes') {
            let taxa
            let taxb
            if (a.type === 'ingredient') {
              taxa = -1
            } else {
              taxa = vm.totalTaxes(a)
            }
            if (b.type === 'ingredient') {
              taxb = -1
            } else {
              taxb = vm.totalTaxes(b)
            }
            if (!isDesc[0]) {
              return parseFloat(taxa) - parseFloat(taxb)
            } else {
              return parseFloat(taxb) - parseFloat(taxa)
            }
          } else if (index[0] === 'utility') {
            let utila
            let utilb
            if (a.type === 'ingredient') {
              utila = -1
            } else {
              utila = parseFloat(vm.getProductUtility(a).split(' ')[1])
            }
            if (b.type === 'ingredient') {
              utilb = -1
            } else {
              utilb = parseFloat(vm.getProductUtility(b).split(' ')[1])
            }
            if (!isDesc[0]) {
              return parseFloat(utila) - parseFloat(utilb)
            } else {
              return parseFloat(utilb) - parseFloat(utila)
            }
          } else if (index[0] === 'porcentualutility') {
            let putila
            let putilb
            if (a.type === 'ingredient') {
              putila = -1
            } else {
              putila = parseFloat(vm.getPorcentualProductUtility(a).split('%')[0])
            }
            if (b.type === 'ingredient') {
              putilb = -1
            } else {
              putilb = parseFloat(vm.getPorcentualProductUtility(b).split('%')[0])
            }
            if (!isDesc[0]) {
              return parseFloat(putila) - parseFloat(putilb)
            } else {
              return parseFloat(putilb) - parseFloat(putila)
            }
          } else if (index[0] === 'sold') {
            let solda = vm.getProductSold(a)
            if (a.magnitude) {
              solda = solda.split(' ')[0]
            }
            let soldb = vm.getProductSold(b)
            if (b.magnitude) {
              soldb = soldb.split(' ')[0]
            }
            if (!isDesc[0]) {
              return parseFloat(solda) - parseFloat(soldb)
            } else {
              return parseFloat(soldb) - parseFloat(solda)
            }
          }
        })
        return items
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      ...mapMutations(['setChange']),
      getBundleStock (bundle) {
        const vm = this
        // let stock = 0;
        try {
          let showLowStockAlert = false
          const location = vm.currentShop
          const ingredients = bundle.ingredients
          let quantities = []
          if (location) {
            ingredients.forEach(function (el) {
              const currentItem = vm.allItems.find(item => item.id === el.id)
              if (currentItem) {
                if (currentItem.location[location.id]) { quantities.push(Math.floor(currentItem.location[location.id].stock / el.amount)) } else quantities.push(0)
              } else quantities.push(0)
            })
            const stock = Math.min(...quantities) || 0
            if (bundle.lowStockAlert && parseFloat(stock) <= parseFloat(bundle.lowStockAlert)) {
              // bundle.location[location.id].showLowStockAlert = true
              showLowStockAlert = true
            } else {
              // bundle.location[location.id].showLowStockAlert = false
              showLowStockAlert = false
            }
            return { result: stock, showLowStockAlert: showLowStockAlert }
          } else {
            let results = 0
            vm.allShops.forEach(function (loc) {
              quantities = []
              ingredients.forEach(function (el) {
                const currentItem = vm.allItems.find(item => item.id === el.id)
                if (currentItem && currentItem.location[loc.id]) {
                  // console.log(currentItem.location[loc.id].stock, el.name)
                  quantities.push(Math.floor(currentItem.location[loc.id].stock / el.amount))
                } else {
                  quantities.push(0)
                }
              })

              results += +Math.min(...quantities)
              const stock = +Math.min(...quantities) || 0
              if (bundle.location[loc.id] && bundle.lowStockAlert && parseFloat(stock) <= parseFloat(bundle.lowStockAlert)) {
                // bundle.location[loc.id].showLowStockAlert = true
                showLowStockAlert = true
              } else if (bundle.location[loc.id]) {
                // bundle.location[loc.id].showLowStockAlert = false
                showLowStockAlert = false
              }
            })
            return { result: results, showLowStockAlert: showLowStockAlert }
          }
        } catch (err) {
          // console.log(err)
          return 0
        }
      },
      getBundleCost (item) {
        const vm = this
        // let stock = 0;
        let result = 0
        item.ingredients.forEach(function (el) {
          const element = vm.allItems.find(item => item.id === el.id)
          if (element) result += element.price ? +element.price.buy : 0
          else result += el.price ? +el.price.buy : 0
        })
        return parseFloat(result).toFixed(2)
      },
      getBundleUtility (item) {
        const vm = this
        return ((vm.getProductPrice(item) - vm.getBundleCost(item)) * 100 / vm.getProductPrice(item)).toFixed(2)
      },
      getProductUtility (item) {
        const vm = this
        if (item.type === 'ingredient') {
          return 'N/A'
        }
        const utilityProd = (vm.getProductPrice(item) - item.price.buy).toFixed(2)
        const productPrice = vm.getProductPrice(item)
        if (productPrice > 0) {
          return '$ ' + utilityProd.toString()
        } else {
          return 'Valide los datos del producto'
        }
      },
      getPorcentualProductUtility (item) {
        const vm = this
        if (item.type === 'ingredient') {
          return 'N/A'
        }
        const utilityProd = vm.getProductPrice(item) - item.price.buy
        const productPrice = vm.getProductPrice(item)
        if (productPrice > 0) {
          return (utilityProd * 100 / productPrice).toFixed(2) + '%'
        } else {
          return 'Valide los datos del producto'
        }
      },
      totalTaxes (item) {
        if (item.type === 'ingredient') {
          return 'N/A'
        }
        let valTaxSum = 0
        let valTaxPercentage = 0
        if (item.taxesLstProduct) {
          for (let i = 0; i < item.taxesLstProduct.length; i++) {
            if (item.taxesLstProduct[i].data.percentage) {
              const div = parseFloat(item.taxesLstProduct[i].data.val) / 100
              const val = 1 + div
              const totVal = parseFloat(val) * parseFloat(item.price.salewithouttax)
              valTaxPercentage = parseFloat(totVal) - parseFloat(item.price.salewithouttax)
            } else {
              valTaxPercentage = parseFloat(item.taxesLstProduct[i].data.val)
            }
            valTaxSum = (parseFloat(valTaxSum) + parseFloat(valTaxPercentage)).toFixed(2)
          }
        }
        return valTaxSum
      },
      onResize () {
        this.isMobile = window.innerWidth < 1024
      },
      getProductStock (item) {
        try {
          let showLowStockAlert = false
          if (this.currentShop) {
            if (item.location[this.currentShop.id]) {
              if (item.lowStockAlert && parseFloat(item.location[this.currentShop.id].stock) <= parseFloat(item.lowStockAlert)) {
                // item.location[this.currentShop.id].showLowStockAlert = true
                showLowStockAlert = true
              } else {
                // item.location[this.currentShop.id].showLowStockAlert = false
                showLowStockAlert = false
              }
              if (item.magnitude) {
                return { result: item.location[this.currentShop.id].stock + ' ' + item.unit, showLowStockAlert: showLowStockAlert }
              } else {
                return { result: item.location[this.currentShop.id].stock, showLowStockAlert: showLowStockAlert }
              }
            } else {
              return ''
            }
          } else {
            let sum = 0
            for (const i in item.location) {
              if (item.location[i]) {
                if (item.lowStockAlert && parseFloat(item.location[i].stock) <= parseFloat(item.lowStockAlert)) {
                  // item.location[i].showLowStockAlert = true
                  showLowStockAlert = true
                } else {
                  // item.location[i].showLowStockAlert = false
                  showLowStockAlert = false
                }
                sum += +item.location[i].stock
              }
            }
            if (item.magnitude) {
              return { result: sum + ' ' + item.unit, showLowStockAlert: showLowStockAlert }
            } else {
              return { result: sum, showLowStockAlert: showLowStockAlert }
            }
          }
        } catch (err) {
          //
          const showLowStockAlert = false
          // console.log(err)
          if (item.magnitude) {
            return { result: item.sold + ' ' + item.unit, showLowStockAlert: showLowStockAlert }
          } else {
            return { result: item.sold, showLowStockAlert: showLowStockAlert }
          }
        }
      },

      getProductSold (item) {
        try {
          let sold
          if (this.currentShop) {
            if (item.location[this.currentShop.id]) {
              sold = item.location[this.currentShop.id].sold || 0
            } else {
              sold = item.sold
            }
          } else {
            sold = item.sold || 0
          }
          return item.magnitude ? sold + ' ' + item.unit : sold
        } catch (err) {
          //
          // console.log(err)
          if (item.magnitude) {
            return (item.sold || 0) + ' ' + item.unit
          } else {
            return item.sold || 0
          }
        }
      },

      getProductPrice (item) {
        try {
          if (this.currentShop && item.location[this.currentShop.id]) {
            if (item.location[this.currentShop.id].pricewithouttax) {
              return item.type === 'ingredient' ? 'N/A' : item.location[this.currentShop.id].pricewithouttax
            } else {
              return item.type === 'ingredient' ? 'N/A' : item.location[this.currentShop.id].price
            }
          } else if (item.price.salewithouttax) {
            return item.type === 'ingredient' ? 'N/A' : item.price.salewithouttax
          } else {
            return item.type === 'ingredient' ? 'N/A' : item.price.sale
          }
        } catch (err) {
          // console.log(err)
          if (item.price.salewithouttax) {
            return item.type === 'ingredient' ? 'N/A' : item.price.salewithouttax
          } else {
            return item.type === 'ingredient' ? 'N/A' : item.price.sale
          }
        }
      },

      fetch () {
        const vm = this
        vm.$store.dispatch('shops/setCurrentItem', null).then(function () {})
      },

      onexport () {
        const vm = this
        const products = []
        // console.log(vm.Items, 'los items')
        vm.Items.forEach(element => {
          // console.log(vm.getProductStock(element), 'el stock')
          const item = {}
          item.nombre = element.name
          item.tipo = element.type
          item.categorias = vm.getCatgoriesProduct(element)
          item.inventario = element.type !== 'bundle' ? vm.getProductStock(element).result : vm.getBundleStock(element).result
          item.inversion = element.type !== 'bundle' ? parseFloat(element.price.buy) : vm.getBundleCost(element)
          item.venta = vm.getProductPrice(element)
          item.impuestos = vm.totalTaxes(element)
          item.utilidad = vm.getProductUtility(element)
          item.utilidad_porcentaje = vm.getPorcentualProductUtility(element)
          item.vendidos = vm.getProductSold(element) || 0
          products.push(item)
        })
        const date = (moment().format('YYYY-MM-DD')).split('-')
        const dateFormated = date[2] + '/' + date[1] + '/' + date[0]
        const fileName = 'inventario_' + dateFormated
        const xls = XLSX.utils.json_to_sheet(products)
        const wb = XLSX.utils.book_new() // make Workbook of Excel
        XLSX.utils.book_append_sheet(wb, xls, 'productos') // sheetAName is name of Worksheet
        XLSX.writeFile(wb, fileName + '.xlsx') // name of the file is 'book.xlsx'
      },
      getCatgoriesProduct (item) {
        let cad = ''
        item.categories.forEach((element, index) => {
          if (index === item.categories.length - 1) {
            cad += element.name
          } else {
            cad += element.name + ', '
          }
        })
        return cad
      },

      setQuery (val) {
        const vm = this
        vm.$store.dispatch('products/setQuery', val).then(function () {})
      },

      showItem (item) {
        const vm = this
        this.$store.dispatch('products/setCurrentItem', item).then(function () {
          vm.dialog = true
        })
      },

      editItem (id) {
        const vm = this
        this.$store.dispatch('products/setCurrentItem', { context: 'properties', id: id }).then(function () {
          vm.updateItemDialog = true
          vm.dialog = false
        })
      },

      openDeleteDialog (currentItem) {
        const vm = this
        vm.currentItemId = currentItem
        vm.confirmationDialog = true
        vm.localLoad = true
        const locations = currentItem.location
        if (currentItem.type !== 'ingredient') {
          for (const key in locations) {
            if (Object.prototype.hasOwnProperty.call(locations, key)) {
              const itemShop = locations[key]
              const inventoryLength = this.$store.getters['products/getItems']
                .filter(item => !!(item.location && item.location[key]) && item.type !== 'ingredient') || []
              if (inventoryLength.length === 1) {
                vm.isLastProductInshop = true
                vm.virtualShopsIdsToDelete.push(key)
                vm.virtualShopsNamesToDelete += itemShop.name + ','
              }
            }
          }
        }
        // Delete product
        Swal.fire({
          title: 'Eliminar Producto',
          text: '¿Deseas continuar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2ca0a5',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.isConfirmed) {
            vm.deleteItem(vm.currentItemId)
          }
        })
      },

      deleteItem (currentItem) {
        // console.log(currentItem)
        const vm = this
        vm.$store.dispatch('products/deleteItem', currentItem).then(function () {
          vm.dialog = false
          if (vm.isLastProductInshop) {
            vm.virtualShopsIdsToDelete.forEach(el => {
              vm.$store.dispatch('shops/deleteVirtualShop', el.id).then(res => {
                vm.virtualShopsNamesToDelete = ''
                vm.isLastProductInshop = false
              })
            })
            vm.virtualShopsIdsToDelete = []
          }
        },
        ).catch(function () {
          vm.dialog = false
        })
      },
      getImage (url) {
        if (url === '') {
          return productPlaceHolder
        } else {
          return url
        }
      },
      selectShop (item) {
        const vm = this
        // console.log(item)
        vm.$store.dispatch('shops/setCurrentItem', item).then(function () {
        })
      },
      clearShopSelection () {
        const vm = this
        vm.$store.dispatch('shops/setCurrentItem', null).then(function () {
        })
      },
      getImageShop (url) {
        // console.log(url)
        if (url === '') {
          return shopPlaceHolder
        } else {
          return url
        }
      },
    },
  }
</script>
<style lang="scss" scoped>

  .products-container{
    display: flex;
      flex-direction: column;
      height: 100vh;
    .products-table-container{
      flex: 1;
      overflow-x: hidden;
      min-width: 100%;

    }

    .categories-container-shop{
      height: 100%;
      max-width: 450px;
    }
    .show-table-mobile{
      padding-bottom: 50px;
    }
    @media(max-width: 770px) {
      .categories-container-shop{
        height: 240px !important;
        padding-top:0;
        padding-bottom: 0;

      }
    }
    @media(min-width: 820px) and (max-width: 920px) {
      .categories-container-shop{
        height: 250px !important;

      }
    }
    @media(min-width: 760px) {
      .show-table-mobile{
        display: none !important;
      }
      .show-table-desktop{
        display: block !important;
      }
    }
    @media(max-width: 1100px) {
      .show-table-mobile{
        display: flex !important;
      }
      .show-table-desktop{
        display: none !important;
      }
      .products-table-container{
        height: 400px !important;
      }
    }
    /* .show-table-mobile{
      @media(max-width: 400px) {
        display: none !important;
      }
    } */
  }
  ::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    /*background-color: #F5F5F5;*/
    border-radius: 10px;
  }

  ::-webkit-scrollbar
  {
    width: 5px;
    @media(min-width: 600px){
      width: 10px;
    }
    /*background-color: #F5F5F5;*/
  }

  ::-webkit-scrollbar-thumb
  {
    border-radius: 10px;
    background-image: -webkit-gradient(linear,
      left bottom,
      left top,
      color-stop(0.44, #008e95),
      color-stop(0.72, #00CAE3),
      color-stop(0.86, #00CAE3));
  }
  .sticky{
    position: sticky;
    top: 0;
    z-index: 1;
    background: #fff;
  }

  .hover-cursor{
    cursor:pointer;
  }

  .card{
    &__confirmation-dialog {
      border: 2px #000 solid;
    }
  }

  .products {
    overflow-y: auto;
    width: 100%;
    &__container {
      max-height: calc(100vh - 100px);
      overflow:hidden;
      margin-top: 1.5rem;
    }

    &__list {
      height: 48vh;
      @media (max-width: 1500px) and (min-width: 1024px) {
        height: 48vh;
      }
      @media (max-width: 1024px) and (max-height: 900px) {
        height: 63vh;
      }
      @media (max-width: 1024px) and (max-height: 750px) {
        height: 58vh;
      }
      @media (max-width: 1024px) and (max-height: 670px) {
        height: 53vh;
      }
      @media (max-width: 1024px) and (max-height: 570px) {
        height: 48vh;
      }
    }
  }

  .product {
    position: relative;
    background: #fff;
    padding: 0;
    margin: 0;
    border-radius: 10px;
    border-bottom-right-radius: 80px;

    &__title-area {
      text-align: center;
      background: #00b6bd;
      border-radius: 10px;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      padding: 3px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #fff;

      &--product {
        background:  #00b6bd !important;
      }

      &--service {
        background:#d62828 !important;
      }

      &--bundle {
        background: #f77f00 !important;
      }

      &--ingredient {
        background: #fcbf49 !important;
      }
    }

    &__title {
      color: #fff;
    }

    &__title--table {
      font-size: 1.2rem;
      max-width: 250px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      @media (max-width: 1500px) {
        font-size: 1rem;
        max-width: 200px;
      }

      @media (max-width: 1300px) {
        font-size: 1rem;
        max-width: 160px;
      }
    }
    &__img {
      display: block;
      height: 5.125rem;
      width: 5.125rem;
      object-fit: cover;
      margin: auto;
      border-radius: 10px;
    }

    &__item-title {
      font-size: .8rem;
      color:#a7a8a8;
      display: block;
    }

    &__item-amount {
      font-size: 1rem;
      font-weight: 800;
      color: #28c1c6;

      &--utility {
        width: 2rem;
        color:#4CAF50;
        display: inline-flex;
      }
    }
  }

  .big-screen-bg{
    @media (min-width: 1500px) {
      background: white;
    }
  }
</style>
